import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ProcessDataSource } from 'src/app/services/process.datasource';
import { SharedService } from 'src/app/services/sharedService';
import { UserService } from 'src/app/services/user.service';
import { YearService } from 'src/app/services/year.service';
import { StatTableActivityComponent } from './stat-table-activity/stat-table-activity.component';

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.css']
})
export class StatisticsComponent implements OnInit {
  statTableActivityComponent = StatTableActivityComponent;
  displayedColumns: string[] = ['link', 'username', 'companyName', 'name', 'status', 'rec_status', 'started_on', 'due_date', 'month'];
  displayedColumnsUserDecActivity: string[] = ['createdBy', 'numOfTaxPayers', 'numOfDeclarations'];
  displayedColumnsAllSubmittedDec: string[] = ['tin', 'companyName', 'municipalityName', 'name', 'year', 'month', 'avisTotal'];
  displayedColumnsInternal: string[] = ['link','name','municipality','status','year','started_on','month']
  currentYear = new Date().getFullYear().toString()
  currentNIU = '';
  displayedYears = []
  dataSource: ProcessDataSource;

  @ViewChild('input', { static: false }) input: ElementRef;

  user: any;
  name: string;
  currentUser
  data
  startYear
  endYear
  year
  municipality
  constructor(
    public userService: UserService,
    public translate: TranslateService,
    public yearService: YearService,
    public dialog: MatDialog, 
    private activatedRoute: ActivatedRoute,
    public sharedService: SharedService,
  ) {
  } 
  async ngOnInit() {
    this.userService.getCurrentUser().subscribe(user =>{
    this.currentUser = user
  })
  try {
    const years = await this.yearService.getList("year").toPromise();
    this.displayedYears = years.map(y => y.year).sort((a, b) => b - a);
    
    if (this.displayedYears.length > 0) {
      this.startYear = this.displayedYears[this.displayedYears.length - 1]; 
      this.endYear = this.displayedYears[0]; 
      this.currentYear = this.endYear.toString();
    }
  } catch (error) {
    console.error(error);
  }
  this.activatedRoute.queryParams.subscribe(params => {
    this.year = params['year'];  
    this.municipality = params['municipality']
    this.data = { currentYear: this.year, municipality: this.municipality };
  });
}
}
